import { ArrowDown } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_meal-manager-37/artifacts/ls65y5w5_image.png";

const t = {
  fr: {
    title: "L'infrastructure qui unifie les repas scolaires",
    subtitle: "Moderniser la gestion des repas scolaires à travers le Québec et le Canada",
    cta: "Voir la Présentation",
  },
  en: {
    title: "The infrastructure that unifies school meals",
    subtitle: "Modernizing school meal management across Quebec and Canada",
    cta: "View Presentation",
  },
};

export default function HeroSection({ lang }) {
  const c = t[lang];
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-darker">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 -right-40 w-96 h-96 bg-primary/20 rounded-full blur-3xl glow-strong animate-pulse" />
        <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-primary/15 rounded-full blur-3xl glow-strong" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-primary/10 rounded-full blur-3xl glow-primary animate-pulse" />
      </div>
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20 sm:py-32">
        <div className="flex justify-center mb-6 sm:mb-8 fade-in">
          <div className="relative">
            <div className="absolute inset-0 blur-3xl opacity-60 bg-primary rounded-full glow-mega animate-pulse" />
            <img alt="EcoLunch" className="relative h-16 sm:h-20 lg:h-24 w-auto drop-shadow-2xl" src={LOGO_URL} />
          </div>
        </div>
        <h1
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-gradient-lime mb-6 sm:mb-8 fade-in drop-shadow-2xl px-4 leading-tight"
          style={{ animationDelay: "0.1s", filter: "drop-shadow(0 0 25px rgba(182,236,19,0.7))" }}
        >
          {c.title}
        </h1>
        <p
          className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto mb-8 sm:mb-12 fade-in font-medium px-4"
          style={{ animationDelay: "0.3s", textShadow: "0 0 15px rgba(255,255,255,0.3)" }}
        >
          {c.subtitle}
        </p>
        <button
          data-testid="hero-cta"
          onClick={() => document.getElementById("summary")?.scrollIntoView({ behavior: "smooth" })}
          className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-hover text-primary-foreground px-6 sm:px-10 py-6 sm:py-8 text-base sm:text-xl rounded-full glow-mega hover:glow-strong transition-all duration-300 hover:-translate-y-2 hover:scale-105 fade-in font-black border-4 border-primary/50"
          style={{ animationDelay: "0.4s" }}
        >
          {c.cta}
          <ArrowDown className="ml-2 h-5 w-5 sm:h-6 sm:w-6" />
        </button>
      </div>
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ArrowDown className="h-6 w-6 sm:h-8 sm:w-8 text-primary glow-primary" style={{ filter: "drop-shadow(0 0 15px rgba(182,236,19,0.9))" }} />
      </div>
    </section>
  );
}
